import React from 'react';
import type { Organism } from '@verndale/core';
import globModules from './glob-modules';
import { renderElement } from './helpers/react-18-shim';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const reactModule = (Component: any, nodeList: NodeListOf<HTMLElement>) => {
  return nodeList.forEach(node => {
    renderElement(<Component {...node.dataset} />, node);
  });
};

const modules: Organism[] = [
  {
    name: 'homepage-masthead',
    loader: () => import('./modules/homepage-masthead')
  },
  {
    name: 'resource-masthead',
    loader: () => import('./modules/resource-masthead')
  },
  {
    name: 'simple-masthead',
    loader: () => import('./modules/simple-masthead')
  },
  {
    name: 'media-masthead',
    loader: () => import('./modules/media-masthead')
  },
  {
    name: 'accordion',
    styles: () => import('../scss/modules/_accordion.scss'),
    loader: () => import('./modules/accordion')
  },
  {
    name: 'mockApi',
    loader: () => import('./modules/mockApi'),
    render: reactModule
  },
  {
    name: 'bubble-images-and-text-row',
    styles: () => import('../scss/modules/_bubble-images-and-text-row.scss'),
    loader: () => import('./modules/bubble-images-and-text-row')
  },
  {
    name: 'media-content-row',
    styles: () => import('../scss/modules/_media-content-row.scss'),
    loader: () => import('./modules/media-content-row')
  },
  {
    name: 'alert-banner',
    loader: () => import('./modules/alert-banner')
  },
  {
    name: 'video',
    loader: () => import('./modules/video')
  },
  {
    name: 'tabbed-cards-container',
    styles: () => import('../scss/modules/_tabbed-cards-container.scss'),
    loader: () => import('./modules/tabbed-cards-container')
  },
  {
    name: 'image-card',
    styles: () => import('../scss/components/_image-card.scss'),
    loader: () => import('./modules/image-card')
  },
  {
    name: 'case-study',
    styles: () => import('../scss/modules/_case-study.scss'),
    loader: () => import('./modules/case-study')
  },
  {
    name: 'image-and-text-cards-carousel',
    styles: () => import('../scss/modules/_image-and-text-cards-carousel.scss'),
    loader: () => import('./modules/image-and-text-cards-carousel')
  },
  {
    name: 'product-images-carousel',
    styles: () => import('../scss/modules/_product-images-carousel.scss'),
    loader: () => import('./modules/product-images-carousel')
  },
  {
    name: 'link-listing',
    styles: () => import('../scss/modules/_link-listing.scss'),
    loader: () => import('./modules/link-listing')
  },
  {
    name: 'informational-card-list',
    styles: () => import('../scss/modules/_informational-card-list.scss'),
    loader: () => import('./modules/informational-card-list')
  },
  {
    name: 'content-cards-container',
    styles: () => import('../scss/modules/_content-cards-container.scss'),
    loader: () => import('./modules/content-cards-container')
  },
  {
    name: 'jump-links',
    styles: () => import('../scss/modules/_jump-links.scss'),
    loader: () => import('./modules/jump-links')
  },
  {
    name: 'authentication-modal',
    styles: () => import('../scss/modules/_authentication-modal.scss'),
    loader: () => import('./modules/authentication-modal')
  },
  {
    name: 'ProductSearchListing',
    styles: () => import('../scss/modules/_product-search-listing.scss'),
    loader: () => import('./modules/react/ProductSearchListing'),
    render: reactModule
  },
  {
    name: 'country-menu',
    styles: () => import('../scss/modules/global/_country-menu.scss'),
    loader: () => import('./modules/country-menu')
  },
  {
    name: 'variants-table',
    loader: () => import('./modules/variants-table')
  },
  {
    name: 'call-to-action-full-width',
    styles: () => import('../scss/modules/_call-to-action-full-width.scss')
  },
  {
    name: 'contact-card-container',
    styles: () => import('../scss/modules/_contact-card-container.scss')
  },
  {
    name: 'footer',
    styles: () => import('../scss/modules/_footer.scss')
  },
  {
    name: 'media-caption',
    styles: () => import('../scss/modules/_media-caption.scss')
  },
  {
    name: 'product-specifications',
    styles: () => import('../scss/modules/_product-specifications.scss')
  },
  {
    name: 'quote-module',
    styles: () => import('../scss/modules/_quote-module.scss')
  }
];

export default [...globModules, ...modules];
